import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { FC, useCallback } from 'react'
import SearchBar, { SearchBarTypes } from '../../../comps/SearchBar/index.web'
import { useStores } from '../../../data/store'
import { useWindowDimensions } from '../../../util/util'
import { SearchViewProps } from '../Header'
import { styles } from './styles'

const SearchView: FC<SearchViewProps> = ({ path, onSearchResultClicked, type }: SearchViewProps) => {
  const { searchData, updateRecents } = useStores((store) => ({
    searchData: store.transactions.getAllTransactions(),
    updateRecents: store.settings.metaData.updateSearhRecents,
    mid: store.user.selectedMid,
  }))

  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles(viewPortWidth)

  const setTxnDetailsVisibility = useCallback(
    (value, txnId, txnDate) => onSearchResultClicked(value, txnId, txnDate),
    [onSearchResultClicked],
  )

  const handleResultClick = (show: boolean, txnId: string = '', filterKey: string = '', txnDate) => {
    setTxnDetailsVisibility(show, txnId, txnDate)
    updateRecents(txnId, filterKey)
  }

  const navigation = useNavigation()

  const searchBoxStyle =
    type === 'initrefund'
      ? ({
          borderWidth: 1,
          borderColor: '#B9CBF0' as ColorOptions,
        } as BoxProps)
      : ({
          shadowOffset: { width: 0, height: 2 },
          shadowRadius: 3,
          shadowColor: '#0000001F' as ColorOptions,
          zIndex: 4,
        } as BoxProps)
  return (
    <Box {...themedStyle.searchContainer} {...searchBoxStyle}>
      <SearchBar
        type={type ?? SearchBarTypes.DEFAULT}
        path={path}
        searchData={searchData}
        onResultClicked={handleResultClick}
        navigation={navigation}
      />
    </Box>
  )
}

export default SearchView
